import { render, staticRenderFns } from "./MasterSecurity.vue?vue&type=template&id=9ba0d588"
import script from "./MasterSecurity.vue?vue&type=script&lang=js"
export * from "./MasterSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports